import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Popup, Icon, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class RemoveIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {'isOpen': false};
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);
  }

  handleOpen() {
    this.setState({'isOpen': true});
  }

  handleClose() {
    this.setState({'isOpen': false});
  }

  handleRemoveClick() {
    this.props.removeElementFromSpecialOrder(this.props.index);
    this.handleClose();
  }

  render() {
    return (
      <Popup inverted wide
        on='click'
        position='top right'
        open={this.state.isOpen}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
        trigger={<Icon link name='close' color='blue' size='large' />}
      >
        <div>
          <div>¿Desea eliminar la línea del pedido?</div>
          <Button secondary onClick={this.handleClose}>CANCELAR</Button>
          <Button primary onClick={this.handleRemoveClick}>ELIMINAR</Button>
        </div>
      </Popup>
    );
  }
}

const {removeElementFromSpecialOrder} = Actions;

export default connect(null, {
  removeElementFromSpecialOrder,
})(RemoveIcon);
